export default __webpack_public_path__ + "static/media/miniLogo.0ef9f304.svg";